App.controller('LifeIncidentCtrl', ['$scope', '$rootScope', '$sce', '$state', '$http', 'packageService', '$stateParams', 'lifeInsuranceService', function ($scope, $rootScope, $sce, $state, $http, packageService, $stateParams, lifeInsuranceService) {
    $scope.stateParams = $stateParams;

    $scope.page = 'life_incident';
    $scope.$emit('page', $scope.page);

    $scope.step = 'Zgłoś zdarzenie';
    $scope.$emit('step', $scope.step);

    $scope.link = 'root.life.start';
    $scope.$emit('link', $scope.link);

    $scope.list = [];

    if ($rootScope.__logged) {
        lifeInsuranceService.getDeclarations().then(function (success) {
            $scope.list = success.data.data;
        });
    }

}]);